/*
 * Fields added to a play after the play type has been chosen.
 * Used to pre-populate values in the form, or can be used as reference
 * when calculating other field values.
 * Not all fields here are directly editable on individual plays, but the majority are.
 */

import {
  getQuarter,
  getDistanceToGo,
  getTeamInPossessionId,
  getDownIsReset,
  getIsChangeInPossession,
  getDown,
  getIncludesTouchdown,
  getYardLine,
  getYardLineTeamId,
  getIsGoalDistanceToGo,
  getBallSpot,
  getBallSpotTeamId
} from "./prePlayHelpers";
import { setNullIfAllowed } from "./actions";

const prePlayChanges = ({
  previousPlay,
  activePlay,
  game,
  clearedFields = []
}) => {
  const { playType } = activePlay;

  const isChangeInPossession = getIsChangeInPossession(previousPlay, playType);
  const downIsReset = getDownIsReset(previousPlay, isChangeInPossession);

  const teamInPossessionId = getTeamInPossessionId(
    previousPlay,
    game,
    isChangeInPossession
  );
  const yardLine = getYardLine(previousPlay, playType);
  const yardLineTeamId = getYardLineTeamId(previousPlay, playType);
  const ballSpot = getBallSpot(playType);
  const ballSpotTeamId = getBallSpotTeamId(playType, teamInPossessionId, game);
  const down = getDown(previousPlay, playType, downIsReset);
  const distanceToGo = getDistanceToGo(previousPlay, playType, downIsReset);
  const isGoalDistanceToGo = getIsGoalDistanceToGo(
    previousPlay,
    isChangeInPossession,
    downIsReset
  );
  const quarter = getQuarter(previousPlay);
  const includesTouchdown = getIncludesTouchdown(playType);
  const lengthOfPlay = 0;

  return {
    ...setNullIfAllowed(activePlay, clearedFields),
    yardLine: yardLine,
    yardLineTeamId: yardLineTeamId,
    ballSpot: ballSpot,
    ballSpotTeamId: ballSpotTeamId,
    down: down,
    distanceToGo: distanceToGo,
    isGoalDistanceToGo: isGoalDistanceToGo,
    teamInPossessionId: teamInPossessionId,
    quarter: quarter,
    includesTouchdown: includesTouchdown,
    lengthOfPlay: lengthOfPlay
  };
};

export { prePlayChanges };
